const ChargeState = {
  notStarted:     'NOT_STARTED', // render nothing
  stopping:       'STOPPING',    // show stopping message, not stop button
  stopFailed:     'STOP_FAILED', // placeholder for handling failed state
  charging:       'CHARGING',    // show charging message
  waiting:        'WAITING',     // show waiting message
  finished:       'FINISHED',    // redirect to finished page
};

export default Object.freeze(ChargeState);